export const convertArray = (items: Array<{ id: number; name: string }>) => {
    return items.map((item) => ({ id: item.id, value: item.name }));
};
